// This function doesn't actually register a component. Instead the task `build-component-registry`
// will analyze the code base and look for calls to this function, and based on the generic
// type build the component registry.
export function registerComponent<T>(component: React.ComponentType<T>) {
  return component;
}

// Does this look wierd? It's because a TypeScript transformer will change the calling code at compile
// time to actually pass in the `type` argument.
// So this:
// const typeName = getComponentName<Api.SomeType>();
//
// Will get compiled down to:
// const typeName = getComponentName<Api.SomeType>('Some.Full.DotNet.Type,Assembly.Name');
export function getComponentName<T>(type?: string) {
  if (type) {
    const [componentName] = type.split(',');
    return componentName;
  }
}

// Same thing as above, the `type` argument is injected during compile time
export function isComponentType<TComponent>(obj: unknown, type?: string): obj is TComponent {
  if (obj && type) {
    const [componentName] = type.split(',');
    return (obj as Excite.ContentApi.IComponent).componentName === componentName;
  }

  return false;
}
